import React from "react";
import "./PrayerTimes.css";

export default function PrayerTimes() {
  const times = [
    { name: "Fajr", time: "5:10 AM" },
    { name: "Dhuhr", time: "12:45 PM" },
    { name: "Asr", time: "4:15 PM" },
    { name: "Maghrib", time: "5:30 PM" },
    { name: "Isha", time: "7:00 PM" },
  ];

  return (
    <section className="prayer-times">
      <h2>Prayer Times</h2>
      <div className="times">
        {times.map((p) => (
          <div key={p.name} className="time-card">
            <h3>{p.name}</h3>
            <p>{p.time}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
